import { render, staticRenderFns } from "./supplierComplianceInspection.vue?vue&type=template&id=150041b2&scoped=true"
import script from "./supplierComplianceInspection.vue?vue&type=script&lang=js"
export * from "./supplierComplianceInspection.vue?vue&type=script&lang=js"
import style0 from "./supplierComplianceInspection.vue?vue&type=style&index=0&id=150041b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150041b2",
  null
  
)

export default component.exports